import IAMReferenceCardCompact from 'pages/CatalogPage/IAM/MaintenancePlan/References/IAMReferenceCardCompact';

export default IAMReferenceCardCompact;
